const dateKey = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    const match = value.trim().match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function resolveEventDayRoute(event, at = Date.now()) {
  const globalRoute = String(event?.routeGPXUrl || "").trim();
  if (globalRoute) return { url: globalRoute, dayIndex: null, source: "global" };

  const days = Array.isArray(event?.meetingPoints) ? event.meetingPoints : [];
  const routes = days
    .map((day, dayIndex) => ({
      day,
      dayIndex,
      url: String(day?.dayGpxUrl || "").trim(),
      date: dateKey(day?.date || day?.startAt),
    }))
    .filter((entry) => entry.url);
  if (!routes.length) return { url: null, dayIndex: null, source: "none" };

  const today = dateKey(at);
  const exact = routes.find((entry) => entry.date && entry.date === today);
  if (exact) return { ...exact, source: "day" };

  // Compatibilidade com eventos antigos cujos dias não têm data própria.
  const eventStart = dateKey(event?.startAt || event?.date);
  if (eventStart) {
    const start = new Date(`${eventStart}T00:00:00`);
    const current = new Date(`${today}T00:00:00`);
    const elapsedDays = Math.floor((current.getTime() - start.getTime()) / 86400000);
    const byOffset = routes.find((entry) => entry.dayIndex === elapsedDays);
    if (byOffset) return { ...byOffset, source: "day_offset" };
  }

  // Fora das datas do evento, escolher o dia com data mais próxima; se não
  // houver datas, usar o primeiro GPX diário disponível.
  const dated = routes.filter((entry) => entry.date);
  if (dated.length) {
    const target = new Date(`${today}T00:00:00`).getTime();
    const nearest = dated.reduce((best, entry) => {
      const distance = Math.abs(new Date(`${entry.date}T00:00:00`).getTime() - target);
      return !best || distance < best.distance ? { entry, distance } : best;
    }, null)?.entry;
    if (nearest) return { ...nearest, source: "nearest_day" };
  }
  return { ...routes[0], source: "first_day" };
}

export function listEventDayRoutes(event) {
  return (Array.isArray(event?.meetingPoints) ? event.meetingPoints : [])
    .map((day, dayIndex) => ({
      dayIndex,
      date: dateKey(day?.date || day?.startAt),
      url: String(day?.dayGpxUrl || "").trim(),
    }))
    .filter((entry) => entry.url);
}
